import { Data } from 'signup-constants/signupData/Data';
import { companyInfo } from '../http-company-info/CompanyInfoClient';
import { handleCompanyInfoError, handleCompanyInfoSuccess } from '../http-company-info/handleCompanyInfoResponse';
import { getIsSuccessfullyVerified, getVerificationType } from '../store/app/selectors';
import { isStepInNextOrCurrentStep } from '../store/flow/selectors';
import { VisitorContextActionTypes } from '../store/visitor-context/action-types';
import { Step } from 'signup-constants/Step';
import { fetchPublicVisitorContext } from '../visitor-context-fetch/fetchPublicVisitorContext';
import { handleVisitorContextSuccess } from '../visitor-context-fetch/handleVisitorContextResponse';
import { EndpointKey } from './EndpointKey';
import { FlowActionTypes } from '../store/flow/action-types';
import { hasEndpointBeenFetched } from '../store/http-responses/selectors';
import { getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { getBreezeCompanyInfo } from '../http-breeze-company-info/BreezeCompanyInfoClient';
import { getGTKMCompanyInfo } from '../http-gtkm-company-info/GTKMCompanyInfoClient';
import { handleBreezeCompanyInfoError, handleBreezeCompanyInfoSuccess } from '../http-breeze-company-info/handleBreezeCompanyInfoResponse';
import { handleGTKMCompanyInfoError } from '../http-gtkm-company-info/handleGTKMCompanyInfoResponse';
import { handleGTKMCompanyInfoSuccess } from '../http-gtkm-company-info/handleGTKMCompanyInfoResponse';
import { getCurrentStep } from '../store/flow/selectors';

// NOTE: This object was wrapped in a function to avoid problematic cycles when frontend-infra-core migrates to Webpack 5
export const getEndpointsPrefilling = () => ({
  [EndpointKey.CompanyInfo]: {
    getRequestData: () => [Data.Email],
    handleError: handleCompanyInfoError,
    handleSuccess: handleCompanyInfoSuccess,
    method: companyInfo,
    stateCheck: state => {
      const isACQ0172VariantB = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0172, [ExperimentParameterGroup.Variant_B]);
      const isACQ0173VariantAorC = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0173, [ExperimentParameterGroup.Variant_A, ExperimentParameterGroup.Variant_C]);

      // Don't invoke the original endpoint for ACQ172 or ACQ173
      if (isACQ0172VariantB || isACQ0173VariantAorC) {
        return false;
      }
      const isVerificationTypeSet = Boolean(getVerificationType(state));
      return isVerificationTypeSet && isStepInNextOrCurrentStep(state, [Step.CompanyDomain, Step.CompanyName, Step.Industry]);
    }
  },
  [EndpointKey.VisitorContextFetch]: {
    handleSuccess: handleVisitorContextSuccess,
    method: fetchPublicVisitorContext,
    reduxActionType: VisitorContextActionTypes.Fetch
  },
  [EndpointKey.BreezeCompanyInfo]: {
    getRequestData: () => [Data.Email],
    handleError: handleBreezeCompanyInfoError,
    handleSuccess: handleBreezeCompanyInfoSuccess,
    method: getBreezeCompanyInfo,
    reduxActionType: FlowActionTypes.GoNextStep,
    once: true,
    stateCheck: state => {
      const endpointHasBeenFetched = hasEndpointBeenFetched(state, EndpointKey.BreezeCompanyInfo);
      if (endpointHasBeenFetched) {
        return false;
      }
      const isACQ0172VariantB = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0172, [ExperimentParameterGroup.Variant_B]);

      // Only invoke this endpoint for ACQ172
      if (!isACQ0172VariantB) {
        return false;
      }
      return getIsSuccessfullyVerified(state);
    }
  },
  [EndpointKey.GTKMCompanyInfo]: {
    getRequestData: () => [Data.Email],
    handleError: handleGTKMCompanyInfoError,
    handleSuccess: handleGTKMCompanyInfoSuccess,
    method: getGTKMCompanyInfo,
    reduxActionType: FlowActionTypes.GoNextStep,
    stateCheck: state => {
      const isACQ0173VariantAorC = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0173, [ExperimentParameterGroup.Variant_A, ExperimentParameterGroup.Variant_C]);
      if (!isACQ0173VariantAorC) {
        return false;
      }
      const currentStep = getCurrentStep(state);
      return currentStep === Step.LoadingPage && getIsSuccessfullyVerified(state);
    }
  }
});